import { Link } from 'react-router-dom'
import apoyo_empresarial from './../img/galerias/apoyo_empresarial.jpg'
import bienestar_social from './../img/galerias/bienestar_social.jpg'
import capacitaciones from './../img/galerias/capacitaciones.jpg'
import fortalecimiento_economico from './../img/galerias/fortalecimiento_economico.jpg'
import gestion_financiera from './../img/galerias/gestion_financiera.jpg'

export default function Eventos() {
  const temas = [
    {
      nombre: 'Apoyo Empresarial',
      imagen: apoyo_empresarial,
      texto: 'Iniciativas que impulsan el crecimiento y fortalecimiento de las empresas locales.',
      ruta: '/galeria/apoyo-empresarial',
    },
    {
      nombre: 'Bienestar Social',
      imagen: bienestar_social,
      texto: 'Actividades y programas que promueven la calidad de vida y la integración comunitaria.',
      ruta: '/galeria/bienestar-social',
    },
    {
      nombre: 'Capacitaciones',
      imagen: capacitaciones,
      texto: 'Espacios de formación para el desarrollo personal y profesional de nuestros participantes.',
      ruta: '/galeria/capacitaciones',
    },
    {
      nombre: 'Fortalecimiento Económico',
      imagen: fortalecimiento_economico,
      texto: 'Proyectos que fomentan la productividad y sostenibilidad de los emprendimientos.',
      ruta: '/galeria/fortalecimiento-economico',
    },
    {
      nombre: 'Gestión Financiera',
      imagen: gestion_financiera,
      texto: 'Estrategias para el manejo eficiente de los recursos y la planeación económica.',
      ruta: '/galeria/gestion-financiera',
    },
  ];

  return (
    <div className='container mt-4'>
      <div className='row justify-content-center'>
        {temas.map((t, i) => (
          <div key={i} className='col-12 col-sm-6 col-md-4 col-lg-2 mb-4'>
            <Link to={t.ruta} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card h-100">
                <img src={t.imagen} className="card-img-top" alt={t.nombre} />
                <div className="card-body">
                  <h6 className="fw-bold">{t.nombre}</h6>
                  <p className="card-text">{t.texto}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
